import {Button, Modal} from '@ds/components';

type ProActionModalProps = {
  isOpen: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ProActionModal: React.FC<ProActionModalProps> = ({isOpen, loading, onClose, onConfirm}) => {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      defaultHeader
      title="آیا مطمئن هستید؟"
      footer={
        <div className="flex justify-between gap-3 border-t border-gray-03 px-4 py-3">
          <Button variant="ghost" color="secondary" onClick={onClose}>
            انصراف
          </Button>
          <Button variant="fill" color="destructive" loading={loading} onClick={onConfirm}>
            بله
          </Button>
        </div>
      }
    >
      <p className="px-4 py-3 text-body-sm text-neutral-fg">
        با توقف اکانت پرو تمامی اطلاعاتی که وارد کردید حذف می‌شود.
      </p>
    </Modal>
  );
};

export default ProActionModal;
